import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AddNode, ClearFilter, DeleteIcon, Edit, EditButtonIcon, FilterIcon, InfoIcon1, RemoveIcon, SaveFilter } from '../../../assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table'
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FilterListIcon from '@mui/icons-material/FilterList';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { IconButton, Tooltip, CircularProgress, Box, Button } from '@mui/material'
import { useHistory } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component'
import filtersConfig from '../Filters'
import DeviceDetails from '../DiscoverDevices/DeviceDetails'
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';

import VideocamIcon from "@mui/icons-material/Videocam";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import ListAltIcon from "@mui/icons-material/ListAlt";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SettingsIcon from "@mui/icons-material/Settings";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CancelIcon from "@mui/icons-material/Cancel";
import { ErrorToast } from "../../../CustomHooks/ErrorToast";
import { useTimezone } from "../../../CustomHooks/useTimezone";
import { getDeviceInformation, getDiscoverDeviceList } from "../../../services/onVifService";
import { SuccessToast } from "../../../CustomHooks/SuccessToast";
import TableViewRoundedIcon from '@mui/icons-material/TableViewRounded';
import { getAllFilters, getAllZoneList, getPreOnBoardedDeviceList, addBulkOnboardStagingDevices, getInterfaceSubTypeData, getOnBoardedDeviceList, onBoardOnVifDevice, updateOnVifDevice, addMultipleDevice } from '../../../services/configurationServices'
import AlertTemplateMessage from '../../Configuration/AlertTemplate/AlertTemplateMessage'
import WebRTCPlayer from '../../Cameras/WebRTCPlayer'
import OnvifManualOnboardModal from '../DiscoverDevices/OnvifManualOnboardModal'

const generateRTSPURLWithCredentials = (rtspURL, username, password) => {
  try {
    const u = new URL(rtspURL);
    if (username) {
      u.username = username;
    }
    if (password) {
      u.password = password;
    }
    return u.toString();
  } catch (err) {
    console.warn("generateRTSPURLWithCredentials: invalid url", rtspURL, err);
    return rtspURL;
  }
};



const ViewDiscoverDevices = ({ showSuccessToast }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { timezone } = useTimezone();

    const getTimeZoneValue = (tzString) => {
        if (!tzString || !timezone) {
            return "1";
        }

        // timezone should be an array of timezone objects (from useTimezone hook)
        const tzArray = Array.isArray(timezone) ? timezone : timezone?.TimeZones || [];

        // Extract offset from timezone string using regex
        const match = tzString.match(/^([+-])(\d{2}):(\d{2})$/);
        if (!match) {
            return "1";
        }

        const sign = match[1]; // '+' or '-'
        const hours = parseInt(match[2], 10);
        const minutes = parseInt(match[3], 10);

        // Calculate offset in minutes
        const offsetMinutes = (sign === '-' ? -1 : 1) * (hours * 60 + minutes);

        // Find matching timezone by comparing OffsetMinutes
        const matchedTz = tzArray.find((tz) => tz.OffsetMinutes === offsetMinutes);
        if (matchedTz) {
            return matchedTz.TimeZoneId.toString();
        }

        return "1";
    };
    const [showAddCustomer, setShowAddCustomer] = useState(false);
    const [showBulkEditModal, setShowBulkEditModal] = useState(false);
    const [showSavedFilterDeleteModal, setShowSavedFilterDeleteModal] = useState(false)
    const [openInfoFilter, setOpenInfoFilter] = useState(false)
    const [modalFilterName, setModalFilterName] = useState("")
    const [selected, setSelected] = useState([]);
    const wrapperRef = useRef(null);
    const [filterValues, setFilterValues] = useState({});
    const [filterData, setFilterData] = useState(null);
    const [customerData, setCustomerData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [showAdditionalModal, setShowAdditionalModal] = useState(false);

    // --- Update Onvif Device modal state ---
    const [onvifIPAddress, setOnvifIPAddress] = useState("");
    const [onvifPort, setOnvifPort] = useState("");
    const [onvifUserName, setOnvifUserName] = useState("");
    const [onvifPassword, setOnvifPassword] = useState("");
    const [onVifIPAddressError, setOnvifIPAddressError] = useState("");
    const [onVifPortError, setOnvifPortError] = useState("");
    const [onVifUserNameError, setOnvifUserNameError] = useState("");
    const [onVifPasswordError, setOnvifPasswordError] = useState("");
    const [deviceInfo, setDeviceInfo] = useState(null);
    const [deviceInfoLoading, setDeviceInfoLoading] = useState(false);
    const [deviceName, setDeviceName] = useState("");
    const [selectedBrand, setSelectedBrand] = useState("");
    const [selectedTimeZone, setSelectedTimeZone] = useState("");
    const [tcpPort, setTcpPort] = useState(8000);
    const [interfaceUserName, setInterfaceUserName] = useState("");
    const [interfacePassword, setInterfacePassword] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [selectedSite, setSelectedSite] = useState("");
    const [onboardSelectedSite, setOnboardSelectedSite] = useState("");
    const [siteSearch, setSiteSearch] = useState("");
    const [modalFilterData, setModalFilterData] = useState([]);
    const [cameraDetails, setCameraDetails] = useState([]);
    const [onBoardedDeviceDetails, setOnBoardedDeviceDetails] = useState(null);
    const [manualOnBoard, setManualOnBoard] = useState(false);
    const [isTwoWayEnabled, setIsTwoWayEnabled] = useState(false);
    const [isHooterEnabled, setIsHooterEnabled] = useState(false);
    const [timeZoneAbreviation, setTimeZoneAbreviation] = useState("");
    const [modalTableFor, setModalTableFor] = useState("camera");

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });
    const [selectedRow, setSelectedRow] = useState(null);
    const [rowSelection, setRowSelection] = useState({});
    const [globalFilter, setGlobalFilter] = useState('');
    const [discoverDeviceData, setDiscoverDeviceData] = useState([]);    
    const [devices, setDevices] = useState([]);
    const [interfaceSubTypeData, setInterfaceSubTypeData] = useState([]);

    const [deviceDetailsByRow, setDeviceDetailsByRow] = useState({});
    const [communicationSettingsByRow, setCommunicationSettingsByRow] = useState({});

  const getInfeterfaceSubTypeId = (manufacturer) => {
    // If manufacturer is empty/undefined/null treat as unknown
    if (!manufacturer) {
      const unk = interfaceSubTypeData.find(
        (item) => item.Interfacesubtypename.toLowerCase() === "unknown",
      );
      return unk ? unk.InterfacesubtypeId : null;
    }
    // return InterfacesubtypeId matching given manufacturer string
    if (!interfaceSubTypeData || interfaceSubTypeData.length === 0) {
      return null;
    }
    const m = manufacturer.toLowerCase().trim();
    // try to find subtype whose name matches or contains manufacturer
    let found = interfaceSubTypeData.find((item) => {
      const name = item.Interfacesubtypename.toLowerCase().trim();
      // First try exact match or substring match
      if (name === m || name.includes(m) || m.includes(name)) {
        return true;
      }
      // Then try normalized match (remove spaces)
      const normalizedM = m.replace(/\s+/g, '');
      const normalizedName = name.replace(/\s+/g, '');
      return normalizedName === normalizedM || normalizedName.includes(normalizedM) || normalizedM.includes(normalizedName);
    });
    if (!found) {
      // fallback: look for ONVIF
      found = interfaceSubTypeData.find(
        (item) => item.Interfacesubtypename.toLowerCase() === "onvif",
      );
    }
    return found ? found.InterfacesubtypeId : null;
  };

    // Enhanced configuration with extensible field mappings
    const getPageConfiguration = () => {
        const pageConfig = filtersConfig.find(config => config.pagename === 'ViewDiscoverDevicesConfiguration');
        if (!pageConfig) {
            console.warn('ViewDiscoverDevicesConfiguration not found in filters config');
            return { filters: {}, fieldMapping: {}, displayConfig: {} };
        }
        return pageConfig;
    };

    const pageConfig = getPageConfiguration();
    const pageFilters = pageConfig.filters;

    // Dynamic field mapping configuration - can be moved to external config
    const defaultFieldMapping = {
        'Customer': 'ClientName',
        'State': 'statename',
        'City': 'City',
        'Site': 'SiteName',
        'Zone': 'ZoneName',
        'Interface': 'InterfaceName',
        'Device': 'DeviceName'
    };

    // Use configured field mapping or fall back to default
    const fieldMapping = pageConfig.fieldMapping || defaultFieldMapping;

    // Get the actual field name from configuration (with fallback to default mapping)
    const getFieldName = (filterKey) => {
        const filterConfig = pageFilters[filterKey];
        if (filterConfig && filterConfig.fieldName) {
            return filterConfig.fieldName;
        }
        return fieldMapping[filterKey] || filterKey;
    };

    // Get placeholder text from configuration
    const getPlaceholderText = (filterKey, filterConfig) => {
        if (filterConfig.placeholder) {
            return filterConfig.placeholder;
        }
        return `Select ${filterConfig.label}${filterConfig.mandatory ? '*' : ''}`;
    };


  // Excel-like Filter Utility - filters options based on other active selections
  const getFilteredOptions = (filterKey, optionKey, labelKey) => {
    if (!filterData || !filterData.Data) {
      return [];
    }

    // Build a filter object with only selected values for each filter (excluding current filter)
    const activeSelections = {};
    Object.keys(pageFilters).forEach((key) => {
      const selected = filterValues[key];
      if (key !== filterKey && Array.isArray(selected) && selected.length > 0) {
        // For State filter, we need to use the statemasterid for comparison
        if (key === "State") {
          activeSelections[key] = selected.map((item) =>
            typeof item === "object" ? item.value : item,
          );
        } else {
          activeSelections[key] = selected.map((item) =>
            typeof item === "object" ? item.value : item,
          );
        }
      }
    });

    // Filter data based on all other active selections
    const filtered = filterData.Data.filter((item) => {
      return Object.entries(activeSelections).every(([key, selectedVals]) => {
        // Use the correct field for comparison
        let compareField;
        if (key === "Customer") {
          compareField = "ClientId";
        } else if (key === "State") {
          compareField = "statemasterid";
        } else if (key === "City") {
          compareField = "City";
        } else if (key === "Site") {
          compareField = "SiteID";
        } else {
          compareField = getFieldName(key);
        }
        return selectedVals.includes(item[compareField]);
      });
    });

    // Get unique options for this filter
    const seen = new Set();
    return filtered
      .filter((item) => {
        const val = item[optionKey];
        if (!val || seen.has(val)) return false;
        seen.add(val);
        return true;
      })
      .map((item) => ({
        label: item[labelKey],
        value: item[optionKey],
      }))
      .sort((a, b) => {
        // Sort options in ascending order by label
        return a.label.localeCompare(b.label, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
  };

  // Create options from API filterData with Excel-like filtering - now fully dynamic
  const getFilterOptions = (filterKey) => {
    if (!filterData || !filterData.Data) {
      return [];
    }

    let optionKey, labelKey;

    if (filterKey === "Customer") {
      // For Customer, use ClientId as value and ClientName as label
      optionKey = "ClientId";
      labelKey = "ClientName";
    } else if (filterKey === "State") {
      // For State, use statemasterid as value and statename as label
      optionKey = "statemasterid";
      labelKey = "statename";
    } else if (filterKey === "City") {
      // For City, use City as both value and label
      optionKey = "City";
      labelKey = "City";
    } else if (filterKey === "Site") {
      // For Site, use SiteID as value and SiteName as label
      optionKey = "SiteID";
      labelKey = "SiteName";
    } else {
      const fieldName = getFieldName(filterKey);
      optionKey = fieldName;
      labelKey = fieldName;
    }

    return getFilteredOptions(filterKey, optionKey, labelKey);
  };

    const handleFilterChange = (filterKey, value) => {
        setFilterValues(prev => {
            const newValues = {
                ...prev,
                [filterKey]: value
            };

            // Smart dependency clearing - clear dependent filters when parent changes
            const filterConfig = pageFilters[filterKey];
            if (filterConfig) {
                // Find and clear all dependent filters
                Object.entries(pageFilters).forEach(([key, config]) => {
                    if (config.parentFilter === filterKey) {
                        newValues[key] = [];
                        // Recursively clear dependencies
                        const clearDependencies = (parentKey) => {
                            Object.entries(pageFilters).forEach(([depKey, depConfig]) => {
                                if (depConfig.parentFilter === parentKey) {
                                    newValues[depKey] = [];
                                    clearDependencies(depKey);
                                }
                            });
                        };
                        clearDependencies(key);
                    }
                });
            }

            return newValues;
        });

        // Only reset table state when mandatory filters are changed
        const filterConfig = pageFilters[filterKey];
        if (filterConfig && filterConfig.mandatory) {
            // Reset table state when mandatory filters change
            setDiscoverDeviceData([]);
            setFiltersApplied(false);
            clearSelection();
            setPagination({
                pageIndex: 0,
                pageSize: 10,
            });
        }
    };

    // Enhanced validation with better error messaging
    const isMandatoryFiltersMissing = () => {
        return Object.entries(pageFilters).some(([filterKey, filterConfig]) => {
            return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
        });
    };

    // Get missing mandatory filters for better user feedback
    const getMissingMandatoryFilters = () => {
        return Object.entries(pageFilters)
            .filter(([filterKey, filterConfig]) => {
                return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
            })
            .map(([filterKey, filterConfig]) => filterConfig.label);
    };

    // Enhanced filter button tooltip
    const getFilterButtonTooltip = () => {
        const missingFilters = getMissingMandatoryFilters();
        if (missingFilters.length > 0) {
            return `Please select: ${missingFilters.join(', ')}`;
        }
        return "Apply Filter";
    };

    // Clear all filters function
    const handleClearAllFilters = () => {
        setFilterValues({});
        setDiscoverDeviceData([]);
        clearSelection();
        setFiltersApplied(false);
        setGlobalFilter('');
        setPagination({
            pageIndex: 0,
            pageSize: 10,
        });
    };

    // Handle global filter change with pagination reset
    const handleGlobalFilterChange = (value) => {
        setGlobalFilter(value);
        // Reset to first page whenever search changes
        setPagination(prev => ({
            ...prev,
            pageIndex: 0
        }));
    };

    // Apply filters function - now calls API and stores response
    const handleApplyFilters = async () => {
         if (!isMandatoryFiltersMissing()) {
              setLoading(true);
              setFiltersApplied(true);
              try {

                //fetch master data
                let obj = {
                    type: "interfacesubtypemaster",
                    parameters: {
                    InterfacetypeId: 1,
                    },
                };
                getInterfaceSubTypeData(obj).then((response) => {
                    if (response && response.Status === "success") {
                    setInterfaceSubTypeData(response.Data);
                    } else {
                    setInterfaceSubTypeData([]);
                    }
                });
                // Prepare filter parameters from selected values
                // Get logged in user ID
                let loggedInUser = JSON.parse(localStorage.getItem('user'));
                const UserID = loggedInUser?.Id;

                // Prepare filter parameters from selected values
                let CustomerID = null;
                let SiteID = null;

                if (filterValues["Customer"] && filterValues["Customer"].length > 0) {
                CustomerID = filterValues["Customer"][0]?.value || filterValues["Customer"][0];
                }
                
                if (filterValues["Site"] && filterValues["Site"].length > 0) {
                SiteID = filterValues["Site"][0]?.value || filterValues["Site"][0];
                }

                setOnboardSelectedSite(SiteID);
        
                const payload = {
                  UserID: UserID,
                  CustomerID: CustomerID,
                  SiteID: SiteID,
                  StageStatus: 'Success',
                };

                const response = await getPreOnBoardedDeviceList(payload);
                if (response && Array.isArray(response.Data)) {
                  const mappedData = response.Data.map(item => {
                    const onvif = item.ONVIFMetaData || {};
                    const profilesRaw = onvif.Profiles || '';
                    const profiles = Array.isArray(profilesRaw)
                      ? profilesRaw
                      : typeof profilesRaw === 'string'
                      ? profilesRaw.split(',').map(p => p.trim()).filter(Boolean)
                      : [];

                    return {
                      id: item.STGDeviceonboardingID,
                      IP: item.DeviceIPAddress ,
                      Port: item.DevicePort || (onvif.NetworkInfo?.HTTPPort ? String(onvif.NetworkInfo.HTTPPort) : null),
                      Name: item.DeviceName ,
                      Hardware: onvif.Model ,
                      DeviceType: onvif.DeviceType ,
                      Profiles: profiles.length ? profiles:null,
                      interfaceusername: "",
                      interfacepassword: "",
                      communicationPort: '8000',
                      raw: item,
                    };
                  });

                  setDiscoverDeviceData(mappedData);
                  // keep editable camera details in state per row
                  const initialDetails = mappedData.reduce((acc, row) => {
                    const rawCameras = row.raw?.ONVIFMetaData?.Cameras || row.raw?.cameras || [];
                    acc[row.id] = rawCameras.map((cam, index) => {
                      const liveType = cam.SubTypeLive === "1" ? "Sub" : "Main";
                      const playbackType = cam.SubTypePlayback === "1" ? "Sub" : "Main";
                      const deviceStageType = cam.DeviceStageId === 2 ? "Live" : "QC Pending";

                      return {
                        id: cam.id || index + 1,
                        selected: cam.selected ?? 1,
                        onboarded: false,
                        CameraName: row.DeviceType === "Camera" ? `${row.Name} - 1` : cam.CameraName || `Cam${cam.channel} - ${row.IP}`,
                        channel: cam.channel,
                        LiveStreamType: liveType,
                        PlayBackStreamType: playbackType,
                        MainRTSPURL: generateRTSPURLWithCredentials(cam.main_rtsp_uri, row.raw?.DeviceUserName , row.raw?.DevicePassword ),
                        SubRTSPURL: Array.isArray(cam.sub_rtsp_uri) ? generateRTSPURLWithCredentials(cam.sub_rtsp_uri[0], row.raw?.DeviceUserName , row.raw?.DevicePassword ) : "",
                        DeviceType: cam.DeviceType,
                        IsTranscodingEnabled: cam.IsTranscodingEnabled,
                        IsPlayBackTranscodingEnabled: cam.IsTranscodingEnabled,
                        IsPtz: cam.IsPtz,
                        IsTwoWayEnabled: row.raw?.ONVIFMetaData?.Capabilities?.Audio ? 1 : 0,
                        ISPlaybackUTC: cam.ISPlaybackUTC,
                        DeviceStageId: deviceStageType,
                        main_rtsp_uri: cam.main_rtsp_uri,
                        AlertService: 1,
                        MonitoringService: 1,
                        HMService: 1,
                        RecordingBackupService: 0,
                        main_bitrate: cam.main_bitrate,
                        main_encoding: cam.main_encoding,
                        main_fps: cam.main_fps,
                        main_resolution_width: cam.main_resolution_width,
                        main_resolution_height: cam.main_resolution_height,
                        sub_bitrate: Array.isArray(cam.sub_bitrate) ? cam.sub_bitrate[0] : "",
                        sub_fps: Array.isArray(cam.sub_fps) ? cam.sub_fps[0] : "",
                        sub_resolution_height: Array.isArray(cam.sub_resolution_height) ? cam.sub_resolution_height[0] : "",
                        sub_resolution_width: Array.isArray(cam.sub_resolution_width) ? cam.sub_resolution_width[0] : "",
                        sub_encoding: Array.isArray(cam.sub_encoding) ? cam.sub_encoding[0] : "",
                        main_profile_token: cam.main_profile_token,
                        main_profile_name: cam.main_profile_name,
                        sub_profile_name: Array.isArray(cam.sub_profile_name) ? cam.sub_profile_name[0] : "",
                        sub_profile_token: Array.isArray(cam.sub_profile_token) ? cam.sub_profile_token[0] : "",
                        sub_rtsp_uri: Array.isArray(cam.sub_rtsp_uri) ? cam.sub_rtsp_uri[0] : "",

                      };
                    });
                    return acc;
                  }, {});
                  setDeviceDetailsByRow(initialDetails);
                } else {
                  setDiscoverDeviceData([]);
                  setDeviceDetailsByRow({});
                  console.warn('No device data received:', response);
                }
              } catch (error) {
                console.error('Error loading devices:', error);
                setDiscoverDeviceData([]);
              } finally {
                setLoading(false);
              }
            }
    };

    useEffect(() => {
        // const fetchFilters = async () => {
        //     try {
        //         const response = await getAllFilters({ Entity: 'Customer' });
        //         setFilterData(response);
        //         console.log('Filter data loaded:', response);
        //     } catch (error) {
        //         console.error('Error loading filters:', error);
        //         setFilterData(null);
        //     }
        // };
        console.log('deviceDetailsByRow',deviceDetailsByRow)
        fetchFilters();
    }, []);
    const fetchFilters = async () => {
        try {
          const response = await getAllFilters({ Entity: "Interface" });
          setFilterData(response);
        } catch (error) {
          console.error("Error loading Device filters:", error);
          setFilterData(null);
        }
      };

    // Clear all selections
    const clearSelection = () => {
        setRowSelection({});
    };

    const columns = useMemo(
        () => [
            //  {
            //     id: "actions",
            //     header: "Play",
            //     size: 80,
            //     enableColumnActions: false,
            //     enableColumnFilter: false,
            //     enableSorting: false,
            //     Cell: ({ row }) => (
            //         <IconButton
            //             aria-label="play"
            //             color="primary"
            //             onClick={() => showModel()}
            //             size="small"
            //             style={{backgroundColor:"#d3d3d3"}}
            //         >
            //             <PlayArrowIcon />
            //         </IconButton>
            //     ),
            // },
            {
                accessorKey: "IP",
                header: "IP",
                size: 80,
            },
            {
                accessorKey: "Port",
                header: "Port",
                size: 80,
            },
            {
                accessorKey: "Name",
                header: "Device name",
                size: 100,
            },
            {
                accessorKey: "Hardware",
                header: "Hardware",
                size: 100,
            },
            {
                accessorKey: "DeviceType",
                header: "Device Type",
                size: 100,
            },
           
            {
                accessorKey: "Profiles",
                header: "Profiles",
                size: 100,
                Cell: ({ cell }) =>
                    Array.isArray(cell.getValue())
                        ? cell.getValue().join(", ")
                        : cell.getValue() || "-",
            },
        ],
        [],
    );

    // API-driven data is stored in discoverDeviceData and shown in the table.
    const getRowDeviceDetails = (row) => {
        if (!row) return [];
        return (
            deviceDetailsByRow[row.id] ||
            row.raw?.ONVIFMetaData?.Cameras ||
            row.raw?.cameras ||
            []
        );
    };

    const buildOnboardPayloadFromRows = (selectedRows) => {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        console.log('selectedRows',selectedRows)
        const result = selectedRows.map((row) => {
            const raw = row.raw || {};
            const cameras = getRowDeviceDetails(row);
            console.log('rowraw 1',row)
            console.log('rowraw',raw)
            console.log('devices',devices)
            console.log('cameras',cameras)
            const selectedDevices = cameras.filter((device) => device.selected === 1)

            const cameraArray = Array.isArray(selectedDevices)
                ? selectedDevices.map((cam, index) => {


                    return {
                        CameraName: cam.CameraName || cam.cameraName || "",
                        ChannelNo: String(cam.channel || cam.ChannelNo || ""),
                        SubTypeLive: cam.LiveStreamType === "Main" ? "0" : "1",
                        SubTypePlayback: cam.PlayBackStreamType === "Main" ? "0" : "1",
                        RTSPURL: cam.LiveStreamType === "Main" ? cam.MainRTSPURL : cam.SubRTSPURL || "",
                        IsTranscodingEnabled: Number(cam.IsTranscodingEnabled || 0),
                        IsPlayBackTranscodingEnabled: Number(cam.IsTranscodingEnabled || 0),
                        IsPtz: Number(cam.IsPtz || 0),
                        isTwoWayEnabled: row?.raw?.ONVIFMetaData?.Capabilities?.Audio ? 1 : 0,
                        cctvHooterEnabledFlag: row?.raw?.ONVIFMetaData?.Capabilities?.Relay ? "1" : "0",
                        ISPlaybackUTC: Number(cam.ISPlaybackUTC || 0),
                        DeviceStageId: cam.DeviceStageId === "Live" ? 2 : 1,
                        MonitoringService: Number(cam.MonitoringService || 0),
                        AlertService: Number(cam.AlertService || 0),
                        HMService: Number(cam.HMService || 0),
                        RecordingBackupService: Number(cam.RecordingBackupService || 0),
                        CCTVTypeID: 6,
                        Isonvif: 1,
                        main_profile_token: cam.main_profile_token || "",
                        main_profile_name: cam.main_profile_name || "",
                        sub_profile_token: Array.isArray(cam.sub_profile_token) ? cam.sub_profile_token[0] : cam.sub_profile_token || "",
                        sub_profile_name: Array.isArray(cam.sub_profile_name) ? cam.sub_profile_name[0] : cam.sub_profile_name || "",
                        Main_Bitrate: cam.main_bitrate ? cam.main_bitrate.toString() : "",
                        Main_Encoding: cam.main_encoding,
                        Main_FPS: cam.main_fps ? cam.main_fps.toString() : "",
                        Main_Resolution: cam.main_resolution_width && cam.main_resolution_height ? `${cam.main_resolution_width} x ${cam.main_resolution_height}` : "",
                        Sub_Bitrate: cam.sub_bitrate ? cam.sub_bitrate.toString() : "",
                        Sub_FPS:  cam.sub_fps ? cam.sub_fps.toString() : "",
                        Sub_Resolution: cam.sub_resolution_width && cam.sub_resolution_height ? `${cam.sub_resolution_width} x ${cam.sub_resolution_height}` : "",
                        Sub_Encoding: cam.sub_encoding,
                        SubRTSPurl:cam.sub_rtsp_uri || "",
                        SiteId: parseInt(onboardSelectedSite) || null,
                        SerialNo: raw.ONVIFMetaData?.SerialNumber || "",
                    };
                })
                : [];

        let entityTypeId;
        if (row?.DeviceType === "NVR") {
            entityTypeId = "4";
        } else if (row?.DeviceType === "DVR") {
            entityTypeId = "5";
        }  else if (row?.DeviceType === "Camera") {
            entityTypeId = "6";
        } 
        const brandId = getInfeterfaceSubTypeId(raw?.ONVIFMetaData?.Manufacturer);
        const TimeZoneID = getTimeZoneValue(raw.ONVIFMetaData?.TimeZone);
        console.log('entityTypeId',entityTypeId)
        console.log('entityTypeId1',devices)
            return {
                InterfaceName: raw.DeviceName || "",
                InterfacetypeId: 1,
                InterfacesubtypeId: brandId,
                InterfaceIP: raw.DeviceIPAddress || "",
                InterfacePort: raw.ONVIFMetaData?.NetworkInfo?.RTSPPort?.toString() || raw.DevicePort || "80",
                UserName: communicationSettingsByRow[row.id]?.interfaceUsername || raw.interfaceusername || "",
                Password: communicationSettingsByRow[row.id]?.interfacePassword || raw.interfacepassword || "",
                siteid: parseInt(onboardSelectedSite) || null,
                isTwoWayEnabled: raw.ONVIFMetaData?.Capabilities?.Audio ? "1" : "0",
                isHooterEnabled: raw.ONVIFMetaData?.Capabilities?.Relay ? "1" : "0",
                CheckInternalHooter: "0",
                CheckExternalHooter: raw.ONVIFMetaData?.Capabilities?.Relay ? "1" :"0",
                LiveRTSPURL: "",
                PlaybackRTSPURL: "",
                CheckPlaybackUTCTime: "0",
                CheckPlaybackLongTime: "0",
                EntityTypeID: entityTypeId,
                TimeZoneID: TimeZoneID,
                OrganizationMasterID: user?.OrganizationMasterID || 1,
                UpdatedateTime: "",
                Communicationport: communicationSettingsByRow[row.id]?.communicationPort || 8000,
                InternetProtocolPort: raw.ONVIFMetaData?.NetworkInfo?.HTTPPort?.toString() || "",
                UserId: user?.Id || "",
                SerialNo: raw.ONVIFMetaData?.SerialNumber || "",
                UserID: user?.Id || "",
                Onvifusername: raw.DeviceUserName || "",
                onvifuserpassword: raw.DevicePassword || "",
                Firmware: raw.ONVIFMetaData?.Firmware || "",
                Profiles: raw.ONVIFMetaData?.Profiles  || "",
                Isonvif: 1,
                STGDeviceonboardingID:row.id,
                cameras: cameraArray,
            };
        });
        console.log('result', result);
        return { devices: result };
    };

    const normalizeDeviceNames = (deviceArray) => {
        if (!Array.isArray(deviceArray)) return [];
        return deviceArray
            .map((item) => {
                if (!item) return "";
                if (typeof item === "string") return item;
                return item.Device || item.Name || "";
            })
            .filter(Boolean);
    };

    const getOnboardResponseMessage = (response) => {
        const successDevices = normalizeDeviceNames(response?.Data?.SuccessDevices);
        const failedDevices = normalizeDeviceNames(response?.Data?.FailedDevices);

        if (successDevices.length > 0 && failedDevices.length === 0) {
            return "Onboarded successfully.";
        }

        if (successDevices.length > 0 && failedDevices.length > 0) {
            const successPart = successDevices.length
                ? `Successfully onboarded: ${successDevices.join(", ")}. `
                : "";
            const failedPart = `Failed to onboard: ${failedDevices.join(", ")}.`;
            return `Some devices onboarded successfully. ${successPart}${failedPart}`.trim();
        }

        if (successDevices.length === 0 && failedDevices.length > 0) {
            return `${response?.Data?.FailedDevices[0]?.Message || "Failed to onboard device."}`;
        }

        return response?.Message || "Onboarding completed.";
    };

    const handleOnboard = async () => {
        const selectedRowKeys = Object.entries(rowSelection)
            .filter(([_, selected]) => selected)
            .map(([key]) => key);

        if (selectedRowKeys.length === 0) {
            ErrorToast("Please select at least one device to onboard.");
            return;
        }

        const selectedRows = selectedRowKeys
            .map((key) =>
                discoverDeviceData.find((row) => String(row.id) === String(key)),
            )
            .filter(Boolean);

        if (selectedRows.length === 0) {
            ErrorToast("Selected rows are not available.");
            return;
        }

        const payload = buildOnboardPayloadFromRows(selectedRows);
        // console.log('Onboard payload', payload);
        // return;

        try {
            const response = await addBulkOnboardStagingDevices(payload);
            const successDevices = normalizeDeviceNames(response?.Data?.SuccessDevices);
            const failedDevices = normalizeDeviceNames(response?.Data?.FailedDevices);
            const message = getOnboardResponseMessage(response);
            const isStatusSuccess = response?.Status === "success";

            if (isStatusSuccess && (successDevices.length > 0 || failedDevices.length === 0)) {
                SuccessToast(message);
                setRowSelection({});
                setDeviceDetailsByRow({});
                await handleApplyFilters();
            } else if (isStatusSuccess && successDevices.length === 0 && failedDevices.length > 0) {
                ErrorToast(message);
            } else {
                ErrorToast(response?.Message || "Onboarding failed");
            }
        } catch (err) {
            console.error("Error onboarding onvif device", err);
            ErrorToast("Error onboarding Onvif devices");
        }
    };

    const onCloseBtn = () => {
        setShowAdditionalModal(false);
        setOnvifIPAddress(""); setOnvifPort(""); setOnvifUserName(""); setOnvifPassword("");
        setOnvifIPAddressError(""); setOnvifPortError(""); setOnvifUserNameError(""); setOnvifPasswordError("");
        setDeviceInfo(null); setDeviceName(""); setSelectedBrand(""); setSelectedTimeZone("");
        setTcpPort(8000); setInterfaceUserName(""); setInterfacePassword("");
        setIsEditMode(false); setSelectedCustomer(""); setSelectedSite(""); setSiteSearch("");
        setCameraDetails([]); setOnBoardedDeviceDetails(null); setManualOnBoard(false);
        setIsTwoWayEnabled(false); setIsHooterEnabled(false); setTimeZoneAbreviation("");
        setDevices([]); setModalTableFor("camera");
    };

    const showModel = async () => {
        setShowAdditionalModal(true);
        getAllFilters({ Entity: "Interface" })
            .then((response) => {
                if (response && response.Status === "success") {
                    setModalFilterData(response.Data);
                } else {
                    setModalFilterData([]);
                }
            })
            .catch(() => setModalFilterData([]));

        let obj = { type: "interfacesubtypemaster", parameters: { InterfacetypeId: 1 } };
        getInterfaceSubTypeData(obj).then((response) => {
            if (response && response.Status === "success") {
                setInterfaceSubTypeData(response.Data);
            } else {
                setInterfaceSubTypeData([]);
            }
        });
    };

    const getTimezoneAbbr = (tzString) => {
        if (!tzString || !timezone) return tzString;

        const tzArray = Array.isArray(timezone)
            ? timezone
            : timezone?.TimeZones || [];

        if (tzArray.length === 0) return tzString;

        const offsetRegex = /([+-])(\d{1,2}):(\d{2})(?::(\d{2}))?/;
        const match = tzString.match(offsetRegex);

        if (!match) return tzString;

        const sign = match[1];
        const hours = parseInt(match[2], 10);
        const minutes = parseInt(match[3], 10);

        let offsetMinutes;

        // GMT+05:30 => standard convention
        if (/^(GMT|UTC)/i.test(tzString)) {
            offsetMinutes = (sign === '-' ? -1 : 1) * (hours * 60 + minutes);
        } 
        // CST-5:30:00 => reversed convention
        else {
            offsetMinutes = (sign === '-' ? 1 : -1) * (hours * 60 + minutes);
        }

        const matchedTz = tzArray.find((tz) => tz.OffsetMinutes === offsetMinutes);

        return matchedTz ? matchedTz.Abbreviation : tzString;
    };


    const getTCPPortDetails = (brand) => {
        const m = brand?.toLowerCase()?.trim();
        if (m === 'cp plus' || m === 'cp_plus' || m === 'cpplus') return 25001;
        if (m === 'dahua') return 37777;
        return 8000;
    };

    const hasData = (data) => {
        if (Array.isArray(data)) return data.length > 0;
        if (data && typeof data === "object") return Object.keys(data).length > 0;
        return false;
        };

    const getOnBoardedDeviceInfo = async (InterfaceIP, InterfaceProtocolPort, shouldUpdateState = true) => {
        const user = JSON.parse(localStorage.getItem("user"));
        const payload = { UserID: user?.Id, InterfaceIP, InterfaceProtocolPort };
        
        try {
            const response = await getOnBoardedDeviceList(payload);
            if (response && response.Status === "success" && hasData(response.Data)) {
                setOnBoardedDeviceDetails(response.Data);
                console.log('Onboarded device details', response.Data);

                if (shouldUpdateState) {
                    setOnvifUserName(response.Data?.onvifusername || "");
                    setOnvifPassword(response.Data?.onvifuserpassword || "");
                    setSelectedCustomer(response.Data?.ClientId ? response.Data.ClientId.toString() : "");
                    setSelectedSite(response.Data?.SiteID ? response.Data.SiteID.toString() : "");
                    setIsEditMode(true);
                    setSelectedBrand(response.Data?.InterfacesubtypeId || "");
                    setTcpPort(response.Data?.Communicationport);
                    setSelectedBrand(response.Data?.InterfacesubtypeId || "");
                    setSelectedTimeZone(response.Data?.TimeZoneID ? response.Data.TimeZoneID.toString() : "");
                    setInterfaceUserName(response.Data?.UserName || "");
                    setInterfacePassword(response.Data?.Password || "");
                    setDeviceName(response.Data?.InterfaceName || "");
                    setIsTwoWayEnabled(response.Data?.isTwoWayEnabled ? true : false);
                    setIsHooterEnabled(response.Data?.isHooterEnabled ? true : false);
                    const dtype = response.Data?.DeviceType?.toLowerCase() || "";
                    setModalTableFor(dtype === "nvr" || dtype === "dvr" ? "nvr/dvr" : "camera");
                }
                return response.Data;
            }
            return null;
        } catch (err) {
            if (shouldUpdateState) {
                setIsEditMode(false);
            }
            console.log(err);
            return null;
        }
    };


    const onSubmitBtn = async () => {
        let isValidate = false;
        if (!onvifUserName) { setOnvifUserNameError("Please enter username"); isValidate = true; } else { setOnvifUserNameError(""); }
        if (!onvifPassword) { setOnvifPasswordError("Please enter password"); isValidate = true; } else { setOnvifPasswordError(""); }
        if (!onvifIPAddress) { setOnvifIPAddressError("Please enter IP address"); isValidate = true; } else { setOnvifIPAddressError(""); }
        if (!onvifPort) { setOnvifPortError("Please enter port"); isValidate = true; } else { setOnvifPortError(""); }
        if (isValidate) return;
        if (!onBoardedDeviceDetails) {
            getOnBoardedDeviceInfo(onvifIPAddress, onvifPort);
        }

        setDeviceInfoLoading(true);
        const IPValue = onvifPort && onvifPort !== "80" ? `${onvifIPAddress}:${onvifPort}` : onvifIPAddress;
        try {
            const response = await getDeviceInformation(IPValue, onvifUserName, onvifPassword);
            if (response && response.Status === "success") {
                setDeviceInfo(response.Data);
                setCameraDetails(response.Data.Cameras || []);
                setTimeZoneAbreviation(getTimezoneAbbr(response.Data.Timezone));
                setDeviceName(onBoardedDeviceDetails?.InterfaceName || `${response.Data.Manufacturer || "Unknown"} - ${IPValue}`);
                SuccessToast("Device information fetched successfully");
            } else {
                setCameraDetails([]); setDeviceInfo(null);
                ErrorToast("Failed to fetch device information");
            }
        } catch (err) {
            console.log(err);
            setDeviceInfo(null); setCameraDetails([]);
            ErrorToast("Error fetching device information");
        } finally {
            setDeviceInfoLoading(false);
        }
    };

    // Sync timezone when abbreviation and timezone data are ready
    React.useEffect(() => {
        if (timeZoneAbreviation && timezone && !isEditMode) {
            const tzArray = Array.isArray(timezone) ? timezone : timezone?.TimeZones || [];
            const matchedTz = tzArray.find((tz) => tz.Abbreviation === timeZoneAbreviation);
            if (matchedTz) setSelectedTimeZone(matchedTz.TimeZoneId.toString());
        }
    }, [timeZoneAbreviation, timezone]);

    // Auto-populate edit-mode fields when device info + subtypes load
    React.useEffect(() => {
        if (deviceInfo && interfaceSubTypeData.length > 0) {
            const brandId = getInfeterfaceSubTypeId(deviceInfo?.Manufacturer);
            const port = getTCPPortDetails(deviceInfo?.Manufacturer);
            if (isEditMode) {
                setTcpPort(onBoardedDeviceDetails?.Communicationport || port);
                setSelectedBrand(onBoardedDeviceDetails?.InterfacesubtypeId || brandId || "");
                setSelectedTimeZone(onBoardedDeviceDetails?.TimeZoneID ? onBoardedDeviceDetails.TimeZoneID.toString() : "");
                setInterfaceUserName(onBoardedDeviceDetails?.UserName || "");
                setInterfacePassword(onBoardedDeviceDetails?.Password || "");
                setDeviceName(onBoardedDeviceDetails?.InterfaceName || "");
                setIsTwoWayEnabled(onBoardedDeviceDetails?.isTwoWayEnabled ? true : false);
                setIsHooterEnabled(onBoardedDeviceDetails?.isHooterEnabled ? true : false);
            } else {
                setTcpPort(port);
                setSelectedBrand(brandId || "");
                setIsTwoWayEnabled(deviceInfo.Capabilities?.Audio ? true : false);
                setIsHooterEnabled(deviceInfo.Capabilities?.Relay ? true : false);
            }
        }
    }, [deviceInfo, interfaceSubTypeData]);

    // Populate devices table from cameraDetails — handles both new-onboard and edit-mode merge
    
    React.useEffect(() => {
        if (!Array.isArray(cameraDetails) || cameraDetails.length === 0) return;

        if (isEditMode) {
            // Merge DB cameras (onboarded: true) with fresh ONVIF channels
            let dbCameras = (onBoardedDeviceDetails?.Cameras || []).filter(
                (c) => c.ParentDeviceID !== null
            );
            let onBoardedCameras = dbCameras.map((c) => {
                const liveType = c.SubTypeLive === 1 ? "Sub" : "Main";
                const playbackType = c.SubTypePlayback === 1 ? "Sub" : "Main";
                const deviceStageType = c.DeviceStageId === 2 ? "Live" : "QC Pending";
                const onvifData = cameraDetails.find((cd) => cd.channel === c.ChannelNo);
                return {
                    ...c,
                    id: c.DeviceId,
                    selected: 1,
                    onboarded: true,
                    CameraName: c.Name,
                    channel: c.ChannelNo,
                    LiveStreamType: liveType,
                    PlayBackStreamType: playbackType,
                    MainRTSPURL: onvifData?.main_rtsp_uri ? generateRTSPURLWithCredentials(onvifData.main_rtsp_uri, onvifUserName,onvifPassword,) : c.RTSPCameraUrl || "",

                    SubRTSPURL: onvifData?.sub_rtsp_uri
                    ? generateRTSPURLWithCredentials(
                        onvifData.sub_rtsp_uri[0],
                        onvifUserName,
                        onvifPassword,
                    )
                    : c.SubRTSPurl ||"",
                    DeviceType: c.EntityType,
                    IsTranscodingEnabled: onvifData ? onvifData?.IsTranscodingEnabled : c.IsTranscodingEnabled,
                    IsPlayBackTranscodingEnabled: onvifData ? onvifData?.IsTranscodingEnabled : c.IsTranscodingEnabled,
                    IsPtz: onvifData ? onvifData?.IsPtz : c.IsPtz,
                    IsTwoWayEnabled: deviceInfo.Capabilities.Audio || 0,
                    ISPlaybackUTC: c.ISPlaybackUTC,
                    DeviceStageId: deviceStageType,
                    main_rtsp_uri: onvifData?.main_rtsp_uri || c.RTSPCameraUrl || "",
                    sub_rtsp_uri: onvifData?.sub_rtsp_uri
                                ? generateRTSPURLWithCredentials(
                                    onvifData.sub_rtsp_uri[0],
                                    onvifUserName,
                                    onvifPassword,
                                )
                                : c.SubRTSPurl ||"",
                    AlertService: c.AlertMonitoring ? 1 : 0,
                    MonitoringService: c.CCTVMonitoring ? 1 : 0,
                    HMService: c.HMMonitoring ? 1 : 0,
                    RecordingBackupService: c.CCTVRecordingBackup ? 1 : 0,
                    main_profile_token: onvifData?.main_profile_token || c.MainProfileToken || "",
                    main_profile_name: onvifData?.main_profile_name || c.MainProfileName || "",
                    sub_profile_name: Array.isArray(onvifData?.sub_profile_name)
                        ? onvifData?.sub_profile_name[0]
                        : c.SubProfileName || "",
                    sub_profile_token: Array.isArray(onvifData?.sub_profile_token)
                        ? onvifData?.sub_profile_token[0]
                        : c.SubProfileToken || "",
                    main_bitrate: onvifData?.main_bitrate || c.Main_Bitrate || "",
                    main_encoding: onvifData?.main_encoding || c.Main_Encoding || "",
                    main_fps: onvifData?.main_fps || c.Main_FPS || "",
                    main_resolution_width: onvifData?.main_resolution_width ? onvifData?.main_resolution_width : c.Main_Resolution ? c.Main_Resolution.split(" x ")[0] : "",
                    main_resolution_height: onvifData?.main_resolution_height ? onvifData?.main_resolution_height : c.Main_Resolution ? c.Main_Resolution.split(" x ")[1] : "",
                    sub_bitrate: Array.isArray(onvifData?.sub_bitrate) ? onvifData?.sub_bitrate[0] : c.Sub_Bitrate || "",
                    sub_fps: Array.isArray(onvifData?.sub_fps) ? onvifData?.sub_fps[0] : c.Sub_FPS || "",
                    sub_resolution_height: Array.isArray(onvifData?.sub_resolution_height) ? onvifData?.sub_resolution_height[0] : c.Sub_Resolution ? c.Sub_Resolution.split(" x ")[0] : "",
                    sub_resolution_width: Array.isArray(onvifData?.sub_resolution_width) ? onvifData?.sub_resolution_width[0]  : c.Sub_Resolution ? c.Sub_Resolution.split(" x ")[1] : "",
                    sub_encoding: Array.isArray(onvifData?.sub_encoding)
                        ? onvifData?.sub_encoding[0]: c.Sub_Encoding || "",
                };
            });

            // New ONVIF channels not yet in DB
            const pendingCameras = cameraDetails.filter(
                (cd) => !dbCameras.some((c) => c.ChannelNo === cd.channel)
            );
            if (pendingCameras.length > 0) {
                const mapped = pendingCameras.map((c) => {
                    const liveType = c.SubTypeLive === "1" ? "Sub" : "Main";
                    const playbackType = c.SubTypePlayback === "1" ? "Sub" : "Main";
                    const deviceStageType = c.DeviceStageId === 2 ? "Live" : "QC Pending";
                    return {
                        ...c,
                        id: c.channel,// use channel as id for pending cameras since they won't have a DeviceId until onboarded
                        selected: 1,
                        onboarded: false,
                        CameraName: c.CameraName,
                        channel: c.channel,
                        LiveStreamType: liveType,
                        PlayBackStreamType: playbackType,
                        MainRTSPURL: c.main_rtsp_uri ? generateRTSPURLWithCredentials(c.main_rtsp_uri, onvifUserName, onvifPassword) : "",
                        SubRTSPURL: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                        DeviceType: c.DeviceType,
                        IsTranscodingEnabled: c.IsTranscodingEnabled,
                        IsPlayBackTranscodingEnabled: c.IsTranscodingEnabled,
                        IsPtz: c.IsPtz,
                        IsTwoWayEnabled: deviceInfo.Capabilities.Audio || 0,
                        ISPlaybackUTC: c.ISPlaybackUTC,
                        DeviceStageId: deviceStageType,
                        // keep original urls around so we can recalc when user changes
                        main_rtsp_uri: c.main_rtsp_uri ? generateRTSPURLWithCredentials(c.main_rtsp_uri, onvifUserName, onvifPassword) : "",
                        sub_rtsp_uri: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                        AlertService: 1,
                        MonitoringService: 1,
                        HMService: 1,
                        RecordingBackupService: 0,
                        main_profile_token: c.main_profile_token,
                        main_profile_name: c.main_profile_name,
                        sub_profile_name: Array.isArray(c.sub_profile_name) ? c.sub_profile_name[0] : "",
                        sub_profile_token: Array.isArray(c.sub_profile_token) ? c.sub_profile_token[0] : "",
                        main_bitrate: c.main_bitrate,
                        main_encoding: c.main_encoding,
                        main_fps: c.main_fps,
                        main_resolution_width: c.main_resolution_width || "",
                        main_resolution_height: c.main_resolution_height || "",
                        sub_bitrate: Array.isArray(c.sub_bitrate) ? c.sub_bitrate[0] : "",
                        sub_fps: Array.isArray(c.sub_fps) ? c.sub_fps[0] : "",
                        sub_resolution_height: Array.isArray(c.sub_resolution_height) ? c.sub_resolution_height[0] : "",
                        sub_resolution_width: Array.isArray(c.sub_resolution_width) ? c.sub_resolution_width[0] : "",
                        sub_encoding: Array.isArray(c.sub_encoding) ? c.sub_encoding[0] : "",
                        ZoneID: selectedSite,
                        SerialNo: deviceInfo?.SerialNumber,
                    };
                });
                onBoardedCameras = [...onBoardedCameras, ...mapped];
            }
            setDevices(onBoardedCameras);
        } else {
            const mapped = cameraDetails.map((c, idx) => {
                const liveType = c.SubTypeLive === "1" ? "Sub" : "Main";
                const playbackType = c.SubTypePlayback === "1" ? "Sub" : "Main";
                const deviceStageType = c.DeviceStageId === 2 ? "Live" : "QC Pending";
                return {
                    id: idx + 1,
                    selected: 1,
                    onboarded: false,
                    CameraName: c.CameraName,
                    channel: c.channel,
                    LiveStreamType: liveType,
                    PlayBackStreamType: playbackType,
                    MainRTSPURL: generateRTSPURLWithCredentials(c.main_rtsp_uri, onvifUserName, onvifPassword),
                    SubRTSPURL: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                    DeviceType: c.DeviceType,
                    IsTranscodingEnabled: c.IsTranscodingEnabled,
                    IsPlayBackTranscodingEnabled: c.IsTranscodingEnabled,
                    IsPtz: c.IsPtz,
                    IsTwoWayEnabled: deviceInfo.Capabilities.Audio || 0,
                    ISPlaybackUTC: c.ISPlaybackUTC,
                    DeviceStageId: deviceStageType,
                    // keep original urls around so we can recalc when user changes
                    main_rtsp_uri: c.main_rtsp_uri,
                    sub_rtsp_uri: Array.isArray(c.sub_rtsp_uri) ? generateRTSPURLWithCredentials(c.sub_rtsp_uri[0], onvifUserName, onvifPassword) : "",
                    AlertService: 1,
                    MonitoringService: 1,
                    HMService: 1,
                    RecordingBackupService: 0,
                    main_profile_token: c.main_profile_token,
                    main_profile_name: c.main_profile_name,
                    sub_profile_name: Array.isArray(c.sub_profile_name) ? c.sub_profile_name[0] : "",
                    sub_profile_token: Array.isArray(c.sub_profile_token) ? c.sub_profile_token[0] : "",
                    main_bitrate: c.main_bitrate,
                    main_encoding: c.main_encoding,
                    main_fps: c.main_fps,
                    main_resolution_width: c.main_resolution_width || "",
                    main_resolution_height: c.main_resolution_height || "",
                    sub_bitrate: Array.isArray(c.sub_bitrate) ? c.sub_bitrate[0] : "",
                    sub_fps: Array.isArray(c.sub_fps) ? c.sub_fps[0] : "",
                    sub_resolution_height: Array.isArray(c.sub_resolution_height) ? c.sub_resolution_height[0] : "",
                    sub_resolution_width: Array.isArray(c.sub_resolution_width) ? c.sub_resolution_width[0] : "",
                    sub_encoding: Array.isArray(c.sub_encoding) ? c.sub_encoding[0] : "",
                    ZoneID: selectedSite,
                    SerialNo: deviceInfo?.SerialNumber,
                };
            });
            setDevices(mapped);
        }
    }, [cameraDetails, isEditMode, onBoardedDeviceDetails]);

    // Trigger auto-submit when edit-mode credentials are populated
    React.useEffect(() => {
        if (onvifUserName && onvifPassword && isEditMode) {
            onSubmitBtn();
        }
    }, [onvifUserName, onvifPassword]);

    const getCameraDetailsForOnboarding = () => {
        const selectedDevices = devices.filter((d) => d.selected === 1);
        return selectedDevices.map((d) => ({
            CameraName: d.CameraName,
            ChannelNo: d.channel.toString(),
            // use numeric codes if system expects 0/1 for main/sub
            SubTypeLive: d.LiveStreamType === "Main" ? "0" : "1",
            SubTypePlayback: d.PlayBackStreamType === "Main" ? "0" : "1",
            RTSPURL: d.LiveStreamType === "Main" ? d.MainRTSPURL : d.SubRTSPURL,
            IsTranscodingEnabled: d.IsTranscodingEnabled || 0,
            IsPlayBackTranscodingEnabled: d.IsTranscodingEnabled || 0,
            IsPtz: d.IsPtz || 0,
            isTwoWayEnabled: d.IsTwoWayEnabled || 0,
            cctvHooterEnabledFlag: isHooterEnabled ? "1" : "0",
            ISPlaybackUTC: d.ISPlaybackUTC || 0,
            DeviceStageId: d.DeviceStageId === "Live" ? 2 : 1,
            AlertService: d.AlertService || 0,
            MonitoringService: d.MonitoringService || 0,
            HMService: d.HMService || 0,
            RecordingBackupService: d.RecordingBackupService || 0,
            main_profile_token: d.main_profile_token || "",
            main_profile_name: d.main_profile_name || "",
            sub_profile_token: Array.isArray(d.sub_profile_token) ? d.sub_profile_token[0] : d.sub_profile_token || "",
            sub_profile_name: Array.isArray(d.sub_profile_name) ? d.sub_profile_name[0] : d.sub_profile_name || "",
            CCTVTypeID: 6,
            Isonvif: 1,
            Main_Bitrate: d.main_bitrate ? d.main_bitrate.toString() : "",
            Main_Encoding: d.main_encoding,
            Main_FPS: d.main_fps ? d.main_fps.toString() : "",
            Main_Resolution: d.main_resolution_width && d.main_resolution_height ? `${d.main_resolution_width} x ${d.main_resolution_height}` : "",
            Sub_Bitrate: d.sub_bitrate ? d.sub_bitrate.toString() : "",
            Sub_FPS:  d.sub_fps ? d.sub_fps.toString() : "",
            Sub_Resolution: d.sub_resolution_width && d.sub_resolution_height ? `${d.sub_resolution_width} x ${d.sub_resolution_height}` : "",
            Sub_Encoding: d.sub_encoding,
            SubRTSPurl:d.sub_rtsp_uri || "",
            SiteId: d.ZoneID,
            SerialNo: d.SerialNo,
        }));
    };

    const getCameraDetailsForUpdate = (updateCameraData) => {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!updateCameraData || updateCameraData.length === 0) return [];
        return updateCameraData.filter((d) => d.onboarded).map((d) => ({
            DeviceId: d.id,
            ParentDeviceID: d?.ParentDeviceID || null,
            ExternalId: "",
            Description: "",
            Metadata: "",
            DeviceTypeID: d.DeviceTypeID || "",
            Lat: d.Lat || 0,
            Long: d.Long || 0,
            Altitude: d.Altitude || 0,
            SiteId: d.ZoneID || parseInt(selectedSite) || onBoardedDeviceDetails?.SiteID || onBoardedDeviceDetails?.ParentSiteID || null,
            InterfaceId: d.InterfaceId || onBoardedDeviceDetails?.InterfaceId || null,
            Name: d.CameraName || "",
            InternetProtocolPort: d.InternetProtocolPort || deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
            isTwoWayEnabled: d.IsTwoWayEnabled ? true : false,
            cctvHooterEnabledFlag: isHooterEnabled ? "1" : "0",
            Communicationport: tcpPort.toString(),
            OrganizationMasterID: d.OrganizationMasterID || null,
            TimeZoneID: selectedTimeZone ? parseInt(selectedTimeZone) : onBoardedDeviceDetails?.TimeZoneID || 0,
            CreatedOn: "",
            ModifiedON: "",
            CreatedBy: "",
            ModifiedBy: user?.Id || null,
            UpdatedateTime: "",
            CameraId: d.id,
            CameraGuid: "",
            IsPtz: d.IsPtz || 0,
            CameraIp: d.CameraIp || onBoardedDeviceDetails?.InterfaceIP || "",
            CameraPort: d.CameraPort || deviceInfo?.NetworkInfo?.RTSPPort?.toString() || deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
            CamUser: interfaceUserName || "",
            CamPassword: interfacePassword || "",
            ChannelNo: d.ChannelNo || "",
            RTSPCameraUrl:  d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
            RTSPURL: d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
            CCTVTypeID: d.CCTVTypeID || 6,
            PlayBackChannelNum: d.PlaybackChannelNum || null,
            IsPlayBackTranscodingEnabled: d.IsTranscodingEnabled || 0,
            IsTranscodingEnabled: d.IsTranscodingEnabled || 0,
            SubTypeLive: d.LiveStreamType === "Main" ? "0" : "1",
            SubTypePlayback: d.PlayBackStreamType === "Main" ? "0" : "1",
            ISPlaybackUTC: d.ISPlaybackUTC || 0,
            HLSStreamingURL: d.HLSStreamingURL || null,
            DeviceStageId: d.DeviceStageId === "Live" ? 2 : 1,
            AlertService: d.AlertService || 0,
            MonitoringService: d.MonitoringService || 0,
            HMService: d.HMService || 0,
            RecordingBackupService: d.RecordingBackupService || 0,
            SerialNo: d.SerialNo || deviceInfo?.SerialNumber || onBoardedDeviceDetails?.SerialNo || onBoardedDeviceDetails?.SerialNumber || "",
            UserID: user?.Id || null,
            MainProfileToken: d.main_profile_token || d.MainProfileToken || "",
            MainProfileName: d.main_profile_name || d.MainProfileName || "",
            SubProfileToken: d.sub_profile_token || d.SubProfileToken || "",
            SubProfileName: d.sub_profile_name || d.SubProfileName || "",
            Isonvif: 1,
            Main_Bitrate: d.main_bitrate ? d.main_bitrate.toString() : d.Main_Bitrate || "",
            Main_Encoding: d.main_encoding || d.Main_Encoding || "",
            Main_FPS: d.main_fps ? d.main_fps.toString() : d.Main_FPS ||"",
            Main_Resolution: d.main_resolution_width && d.main_resolution_height ? `${d.main_resolution_width} x ${d.main_resolution_height}` : d.Main_Resolution || "",
            Sub_Bitrate: d.sub_bitrate ? d.sub_bitrate.toString() : d.Sub_Bitrate ||"",
            Sub_FPS:  d.sub_fps ? d.sub_fps.toString() : d.Sub_FPS ||"",
            Sub_Resolution: d.sub_resolution_width && d.sub_resolution_height ? `${d.sub_resolution_width} x ${d.sub_resolution_height}` : d.Sub_Resolution || "",
            Sub_Encoding: d.sub_encoding || d.Sub_Encoding || "",
            SubRTSPurl:d.sub_rtsp_uri || d.SubRTSPURL || ""
        }));
    };

    const validateModalForm = () => {
        let isValid = true;
        if (!deviceName) isValid = false;
        if (!tcpPort) isValid = false;
        return isValid;
    };

    const onBoardDevice = async () => {
        if (!validateModalForm()) {
            ErrorToast("Please fill in Device Name and TCP Port before onboarding.");
            return;
        }
        const user = JSON.parse(localStorage.getItem("user"));
        const UserId = user?.Id;
        const OrganizationMasterID = user?.OrganizationMasterID;

        if (isEditMode) {
            const deviceToUpdate = devices.filter((d) => d.selected === 1 && d.onboarded === true);
            const deviceToAdd = devices.filter((d) => d.selected === 1 && d.onboarded === false);
            let entityTypeId;
            if (deviceInfo?.DeviceType === "NVR") {
                entityTypeId = "4";
            } else if (deviceInfo?.DeviceType === "DVR") {
                entityTypeId = "5";
            }  else if (deviceInfo?.DeviceType === "Camera") {
                entityTypeId = "6";
            } 
            let camerasToUpdate = getCameraDetailsForUpdate(deviceToUpdate)
            const updatePayload = {
                InterfaceId: onBoardedDeviceDetails?.InterfaceId?.toString(),
                InterfaceName: deviceName,
                InterfacetypeId: 1,
                InterfacesubtypeId: selectedBrand,
                InterfaceIP: onvifIPAddress,
                InterfacePort: deviceInfo.NetworkInfo.RTSPPort?.toString() || '',
                UserName: interfaceUserName || "",
                Password: interfacePassword || "",
                siteid: parseInt(selectedSite) || null,
                isTwoWayEnabled: isTwoWayEnabled ? "1" : "0",
                isHooterEnabled: isHooterEnabled  ? "1" : "0",
                CheckInternalHooter: "0",
                CheckExternalHooter: isHooterEnabled  ? "1" : "0",
                LiveRTSPURL: "",
                PlaybackRTSPURL: "",
                CheckPlaybackUTCTime: "0",
                CheckPlaybackLongTime: "0",
                EntityTypeID: entityTypeId,
                TimeZoneID: selectedTimeZone || '1',
                OrganizationMasterID: OrganizationMasterID,
                UpdatedateTime: "",
                Communicationport: tcpPort.toString(),
                InternetProtocolPort: deviceInfo?.NetworkInfo?.HTTPPort || "",
                UserId: UserId,
                onvifusername: onvifUserName,
                onvifuserpassword: onvifPassword,
                Firmware: deviceInfo?.Firmware || "",
                SerialNo: deviceInfo?.SerialNumber || onBoardedDeviceDetails?.SerialNo || "",
                UserID: UserId,
                profiles: deviceInfo?.Profiles.join(', ') || "",
                Isonvif: 1,
                cameras: camerasToUpdate,
            };

            try {
                const response = await updateOnVifDevice(updatePayload);
                if (response && response.Status === "success") {
                    SuccessToast("Onvif device updated successfully");
                    onCloseBtn();
                } else {
                    ErrorToast(response?.Message || "Update failed");
                }
            } catch (error) {
                ErrorToast("Error updating Onvif device");
            }

            // Add new ONVIF channels not yet in DB
            if (deviceToAdd.length > 0) {
                let zerochanelDevices = onBoardedDeviceDetails?.Cameras?.find((d) => d.ParentDeviceID === null);
                let latestDeviceDetails = onBoardedDeviceDetails;
                
                if(!zerochanelDevices){
                    const fetchedDeviceData = await getOnBoardedDeviceInfo(onvifIPAddress, onvifPort, false);
                    if (fetchedDeviceData) {
                        latestDeviceDetails = fetchedDeviceData;
                        zerochanelDevices = fetchedDeviceData?.Cameras?.find((d) => d.ParentDeviceID === null);
                    }
                }

                const newParentDeviceId = zerochanelDevices?.DeviceId || latestDeviceDetails?.InterfaceId || null;
                const zeroChannelSiteId = latestDeviceDetails?.ParentSiteID || parseInt(selectedSite) || latestDeviceDetails?.SiteID || null;
                const zeroChannelSerial = deviceInfo?.SerialNumber || latestDeviceDetails?.SerialNo || latestDeviceDetails?.SerialNumber || "";

                const addPayload = {
                    cameras: deviceToAdd.map((d) => ({
                        ParentDeviceID: newParentDeviceId,
                        ExternalId: "",
                        Description: "",
                        Metadata: "",
                        DeviceTypeID:6,
                        Lat: zerochanelDevices?.Lat || 0,
                        Long: zerochanelDevices?.Long || 0,
                        Altitude: zerochanelDevices?.Altitude || 0,
                        SiteId: zerochanelDevices?.ZoneID || zeroChannelSiteId,
                        InterfaceId: latestDeviceDetails?.InterfaceId || null,
                        Name: d.CameraName || "",
                        InternetProtocolPort: deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
                        isTwoWayEnabled: d.IsTwoWayEnabled || 0,
                        cctvHooterEnabledFlag: isHooterEnabled ? "1" : "0",
                        Communicationport: tcpPort.toString(),
                        OrganizationMasterID: OrganizationMasterID,
                        TimeZoneID: selectedTimeZone ? parseInt(selectedTimeZone) : 0,
                        CreatedOn: "",
                        ModifiedON: "",
                        CreatedBy: user?.Id || null,
                        ModifiedBy: "",
                        UpdatedateTime: "",
                        CameraId: 0,
                        CameraGuid: "",
                        IsPtz: d.IsPtz || 0,
                        CameraIp: onBoardedDeviceDetails?.InterfaceIP || "",
                        CameraPort: deviceInfo?.NetworkInfo?.RTSPPort?.toString() || deviceInfo?.NetworkInfo?.HTTPPort?.toString() || "",
                        CamUser: interfaceUserName || "",
                        CamPassword: interfacePassword || "",
                        ChannelNo: d.channel.toString(),
                        CCTVTypeID: 6,
                        RTSPCameraUrl: d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
                        RTSPURL: d.LiveStreamType === "Main" ? (d.MainRTSPURL || d.SubRTSPURL || d.main_rtsp_uri || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "")) : (d.SubRTSPURL || d.MainRTSPURL || (Array.isArray(d.sub_rtsp_uri) ? d.sub_rtsp_uri[0] : "") || d.main_rtsp_uri || ""),
                        PlayBackChannelNum: 1,
                        SubTypeLive: d.LiveStreamType === "Main" ? "0" : "1",
                        SubTypePlayback: d.PlayBackStreamType === "Main" ? "0" : "1",
                        IsTranscodingEnabled: d.IsTranscodingEnabled || 0,
                        IsPlayBackTranscodingEnabled: d.IsTranscodingEnabled || 0,
                        ISPlaybackUTC: d.ISPlaybackUTC || 0,
                        HLSStreamingURL: null,
                        DeviceStageId: d.DeviceStageId === "Live" ? 2 : 1,
                        AlertService: d.AlertService || 0,
                        MonitoringService: d.MonitoringService || 0,
                        HMService: d.HMService || 0,
                        RecordingBackupService: d.RecordingBackupService || 0,
                        SerialNo: zeroChannelSerial,
                        UserID: user?.Id || null,
                        Isonvif: 1,
                        MainProfileToken: d.main_profile_token || d.MainProfileToken || "",
                        MainProfileName: d.main_profile_name || d.MainProfileName || "",
                        SubProfileToken: d.sub_profile_token || d.SubProfileToken || "",
                        SubProfileName: d.sub_profile_name || d.SubProfileName || "",
                        Main_Bitrate: d.main_bitrate ? d.main_bitrate.toString() : d.Main_Bitrate || "",
                        Main_Encoding: d.main_encoding || d.Main_Encoding || "",
                        Main_FPS: d.main_fps ? d.main_fps.toString() : d.Main_FPS ||"",
                        Main_Resolution: d.main_resolution_width && d.main_resolution_height ? `${d.main_resolution_width} x ${d.main_resolution_height}` : d.Main_Resolution || "",
                        Sub_Bitrate: d.sub_bitrate ? d.sub_bitrate.toString() : d.Sub_Bitrate ||"",
                        Sub_FPS:  d.sub_fps ? d.sub_fps.toString() : d.Sub_FPS ||"",
                        Sub_Resolution: d.sub_resolution_width && d.sub_resolution_height ? `${d.sub_resolution_width} x ${d.sub_resolution_height}` : d.Sub_Resolution || "",
                        Sub_Encoding: d.sub_encoding || d.Sub_Encoding || "",
                        SubRTSPurl:d.sub_rtsp_uri || d.SubRTSPURL || ""
                    })),
                };
                addMultipleDevice(addPayload)
                    .then((res) => {
                        if (res && res.Status === "success") {
                            SuccessToast("New channels added successfully");
                        } else {
                            ErrorToast(res?.Message || "Error adding new channels");
                        }
                    })
                    .catch(() => ErrorToast("Error adding new channels"));
            }

            
            return;
        }
        let entityTypeId;
        if (deviceInfo?.DeviceType === "NVR") {
            entityTypeId = "4";
        } else if (deviceInfo?.DeviceType === "DVR") {
            entityTypeId = "5";
        }  else if (deviceInfo?.DeviceType === "Camera") {
            entityTypeId = "6";
        } 
        const payload = {
            InterfaceName: deviceName,
            InterfacetypeId: 1,
            InterfacesubtypeId: selectedBrand,
            InterfaceIP: onvifIPAddress,
            InterfacePort: deviceInfo.NetworkInfo.RTSPPort?.toString() || '',
            UserName: interfaceUserName || "",
            Password: interfacePassword || "",
            siteid: parseInt(selectedSite) || null,
            isTwoWayEnabled: isTwoWayEnabled ? "1" : "0",
            isHooterEnabled: isHooterEnabled ? "1" : "0",
            CheckInternalHooter: "0",
            CheckExternalHooter: isHooterEnabled ? "1" : "0",
            LiveRTSPURL: "",
            PlaybackRTSPURL: "",
            CheckPlaybackUTCTime: "0",
            CheckPlaybackLongTime: "0",
            EntityTypeID: entityTypeId.toString(),
            TimeZoneID: selectedTimeZone || '1',
            OrganizationMasterID: OrganizationMasterID,
            UpdatedateTime: "",
            Communicationport: tcpPort.toString(),
            InternetProtocolPort: deviceInfo?.NetworkInfo?.HTTPPort || "",
            UserId: UserId,
            Onvifusername: onvifUserName,
            onvifuserpassword: onvifPassword,
            Firmware: deviceInfo?.Firmware || "",
            Profiles: deviceInfo?.Profiles.join(', ') || "",
            SerialNo: deviceInfo?.SerialNumber || "",
            UserID: UserId,
            Isonvif: 1,
            cameras: getCameraDetailsForOnboarding(),
        };
        onBoardOnVifDevice(payload).then((response) => {
            if (response && response.Status === "success") {
                SuccessToast("Onvif device onboarded successfully");
                onCloseBtn();
            } else {
                ErrorToast(response?.Message || "Onboarding failed");
            }
        }).catch(() => ErrorToast("Error onboarding Onvif device"));
    };

    const modalCustomerOptions = React.useMemo(() => {
        const uniqueCustomers = [];
        const seenIds = new Set();
        modalFilterData.forEach((item) => {
            if (!seenIds.has(item.ClientId)) {
                uniqueCustomers.push({ id: item.ClientId, name: item.ClientName });
                seenIds.add(item.ClientId);
            }
        });
        return uniqueCustomers;
    }, [modalFilterData]);

    const modalSiteOptions = React.useMemo(() => {
        if (!selectedCustomer) return [];
        const sites = [];
        const seenIds = new Set();
        modalFilterData.forEach((item) => {
            if (item.ClientId === parseInt(selectedCustomer) && !seenIds.has(item.SiteID) && item.SiteID !== null && item.SiteName !== null) {
                sites.push({ id: item.SiteID, name: item.SiteName });
                seenIds.add(item.SiteID);
            }
        });
        return sites;
    }, [selectedCustomer, modalFilterData]);
    return (
        <>
        <div className='p-3'>
            <div className="SiteMainContainer SiteTableMainDiv">
                <div className="DashboardFilterMainDiv">
                    <div className="RefreshText" style={{ display: "flex" }}>
                        {Object.entries(pageFilters)
                            .sort(([, a], [, b]) => a.sequence - b.sequence)
                            .map(([filterKey, filterConfig]) => (
                                <div key={filterKey} className="inputTypeLabelContainer">
                                    <label className="formFieldLabels">
                                        {filterConfig.label}
                                        {filterConfig.mandatory && (
                                            <span style={{ color: "red" }}>*</span>
                                        )}
                                    </label>
                                    <div ref={wrapperRef}>
                                        <MultiSelect
                                            key={filterValues[filterKey]?.[0]?.value}
                                            options={getFilterOptions(filterKey)}
                                            value={filterValues[filterKey] || []}
                                            onChange={(value) =>
                                                handleFilterChange(
                                                    filterKey,
                                                    value.length > 1
                                                        ? [value[value.length - 1]]
                                                        : value,
                                                )
                                            }
                                            labelledBy={`Select ${filterConfig.label}`}
                                            hasSelectAll={false}
                                            isCreatable={false}
                                            disableSearch={false}
                                            className="SiteConfigSingleSelectDropdownContainer"
                                            overrideStrings={{
                                                selectSomeItems:
                                                    filterValues[filterKey] &&
                                                        filterValues[filterKey][0] &&
                                                        filterValues[filterKey][0].label
                                                        ? filterValues[filterKey][0].label
                                                        : getPlaceholderText(filterKey, filterConfig),
                                                allItemsAreSelected:
                                                    filterValues[filterKey] &&
                                                        filterValues[filterKey][0] &&
                                                        filterValues[filterKey][0].label
                                                        ? filterValues[filterKey][0].label
                                                        : getPlaceholderText(filterKey, filterConfig),
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        <div className="HMFilterDiv">
                            <Tooltip title={getFilterButtonTooltip()} placement="bottom">
                                <button
                                    className="IconsButtonDiv"
                                    name="filterBtn"
                                    disabled={isMandatoryFiltersMissing() || loading}
                                    style={{
                                        opacity: isMandatoryFiltersMissing() || loading ? 0.5 : 1,
                                        cursor:
                                            isMandatoryFiltersMissing() || loading
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={handleApplyFilters}
                                >
                                    <img
                                        src={FilterIcon}
                                        className="camera-icon-height"
                                        alt="Apply filter icon"
                                    />
                                </button>
                            </Tooltip>
                            <Tooltip title="Clear Filter" placement="bottom">
                                <button
                                    className="IconsButtonDiv"
                                    name="clearFilterBtn"
                                    disabled={loading}
                                    style={{
                                        opacity: loading ? 0.5 : 1,
                                        cursor: loading ? "not-allowed" : "pointer",
                                    }}
                                    onClick={handleClearAllFilters}
                                >
                                    <img
                                        src={ClearFilter}
                                        className="camera-icon-height"
                                        alt="Clear filter icon"
                                    />
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className="SiteMainHeightDiv">
                    <div className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv" style={{ height: "calc(100vh - 290px)" }}>
                        <div className="card-body p-0" >
                            {loading ? (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    minHeight="400px"
                                    flexDirection="column"
                                >
                                    <CircularProgress size={60} thickness={4} />
                                    <Box mt={2}>
                                        <span style={{ fontSize: "16px", color: "#666" }}>
                                            Loading device data...
                                        </span>
                                    </Box>
                                </Box>
                            ) : discoverDeviceData.length === 0 ? (
                                <div
                                    style={{
                                        width: "100%",
                                        padding: "20px",
                                        textAlign: "center",
                                    }}
                                >
                                    <AlertTemplateMessage
                                        message={
                                            !filtersApplied || isMandatoryFiltersMissing()
                                                ? "Please select mandatory filters and click Apply Filter to load device data."
                                                : "No device found for the selected filters. Please add a device"
                                        }
                                    />
                                </div>
                            ) : (
                                <MaterialReactTable
                                    columns={columns}
                                    data={discoverDeviceData}
                                    getRowId={(row) => String(row.id)}
                                    enableRowSelection
                                    enableExpanding
                                    columnOrder={['mrt-row-select', 'actions', 'IP', 'Port', 'Name', 'Hardware', 'DeviceType', 'Profiles', 'mrt-row-expand']}
                                    renderDetailPanel={({ row }) => (
                                        <Box sx={{
                                            width: "100%",
                                            boxSizing: "border-box",
                                            overflow: "hidden",}}>
                                            <div
                                                className="DiscoverFormAdditionForm border-top-0"
                                                style={{ height: "520px", overflowY: "auto", width:"1590px"}}
                                            >
                                                <div className="device-info-container">
                                                    {/* Device Overview */}
                                                    <div className="section">
                                                        <div className="section-title">
                                                            <ListAltIcon sx={{ color: "#455a64", mr: 1 }} />
                                                            Device Overview
                                                        </div>

                                                        <div className="info-box">
                                                            <div className="info-row">
                                                                <span className="label">
                                                                    Device Name
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="value"
                                                                    value={row.original.Name }
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="info-row">
                                                                <span className="label">System</span>
                                                                <span className="value">CCTV</span>
                                                            </div>
                                                            <div className="info-row">
                                                                <span className="label">Brand</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Manufacturer }
                                                                </span>

                                                            </div>
                                                            <div className="info-row">
                                                                <span className="label">Device Type</span>
                                                                <span className="value">
                                                                    {row.original.DeviceType }
                                                                </span>
                                                            </div>
                                                            <div className="info-row">
                                                                <span className="label">Firmware</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Firmware }
                                                                </span>
                                                            </div>


                                                            <div className="info-row">
                                                                <span className="label">Serial Number</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.SerialNumber }
                                                                </span>
                                                            </div>



                                                            <div className="info-row">
                                                                <span className="label">Timezone</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Timezone }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Network Details */}
                                                    <div className="section">
                                                        <div className="section-title">
                                                            <NetworkCheckIcon sx={{ color: "#0288d1", mr: 1 }} />
                                                            Network Details
                                                        </div>

                                                        <div className="info-box">
                                                            <div className="info-row">
                                                                <span className="label">IP Address</span>
                                                                <span className="value" style={{ textAlign: "right" }}>
                                                                    {row.original.IP }
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">HTTP Port</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.NetworkInfo?.HTTPPort }
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">RTSP Port</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.NetworkInfo?.RTSPPort }
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">TCP Port</span>
                                                                <input
                                                                    type="text"
                                                                    className="value"
                                                                    value={communicationSettingsByRow[row.original.id]?.communicationPort || 8000}
                                                                    onChange={(e) => setCommunicationSettingsByRow(prev => ({...prev, [row.original.id]: {...(prev[row.original.id] || {}), communicationPort: e.target.value}}))}
                                                                    style={{
                                                                        border: `1px solid #0b70d1`,
                                                                        padding: "2px 4px",
                                                                        borderRadius: "2px",
                                                                        width: "auto",
                                                                        maxWidth: "5%",
                                                                        background: "transparent",
                                                                        textAlign: "right",
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Capabilities */}
                                                    <div className="section">
                                                        <div className="section-title">
                                                            <SettingsIcon sx={{ color: "#f57c00", mr: 1 }} />
                                                            Capabilities
                                                        </div>

                                                        <div className="info-box">
                                                            <div className="info-row">
                                                                <span className="label">Profiles</span>
                                                                <span className="value">
                                                                    {Array.isArray(row.original.Profiles)
                                                                        ? row.original.Profiles.join(', ')
                                                                        : row.original.Profiles }
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">PTZ</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Capabilities?.PTZ
                                                                        ? (
                                                                            <>
                                                                                <CheckCircleIcon sx={{ color: '#2e7d32', mr: 0.5 }} />
                                                                                Supported
                                                                            </>
                                                                        )
                                                                        : (
                                                                            <>
                                                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                                Not Supported
                                                                            </>
                                                                            )}
                                                                </span>
                                                            </div>
                                                            <div className="info-row">
                                                                <span className="label">Events</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Capabilities?.Events
                                                                            ? (
                                                                                <>
                                                                                    <CheckCircleIcon sx={{ color: '#2e7d32', mr: 0.5 }} />
                                                                                    Supported
                                                                                </>
                                                                            )
                                                                            : (
                                                                                <>
                                                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                                Not Supported
                                                                                </>
                                                                            )}
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">Two Way Audio</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Capabilities?.Audio
                                                                            ? (
                                                                                <>
                                                                                    <CheckCircleIcon sx={{ color: '#2e7d32', mr: 0.5 }} />
                                                                                    Supported
                                                                                </>
                                                                            )
                                                                            : (
                                                                                <>
                                                                                <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                                Not Supported
                                                                                </>
                                                                            )}
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">Hooter</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Capabilities?.Relay
                                                                            ? (
                                                                                <>
                                                                                    <CheckCircleIcon sx={{ color: '#2e7d32', mr: 0.5 }} />
                                                                                    Supported
                                                                                </>
                                                                            )
                                                                            : (
                                                                                <>
                                                                                    <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                                    Not Supported
                                                                                </>
                                                                            )}
                                                                </span>
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">Video Analytics</span>
                                                                <span className="value">
                                                                    {row.original.raw?.ONVIFMetaData?.Capabilities?.VideoAnalytics
                                                                            ? (
                                                                                <>
                                                                                    <CheckCircleIcon sx={{ color: '#2e7d32', mr: 0.5 }} />
                                                                                    Supported
                                                                                </>
                                                                            )
                                                                            : (
                                                                                <>
                                                                                    <CancelIcon sx={{ color: "#d32f2f", mr: 0.5 }} />
                                                                                    Not Supported
                                                                                </>
                                                                            )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* Communication Settings */}
                                                    <div className="section">
                                                        <div className="section-title">
                                                            <ConnectWithoutContactIcon sx={{ color: "#d11d62", mr: 1 }} />
                                                            Communication Settings
                                                        </div>


                                                        <div className="info-box">
                                                            <div className="info-row">
                                                                <span className="label">Interface Username</span>
                                                                <input
                                                                    type="text"
                                                                    className="value"
                                                                    value={communicationSettingsByRow[row.original.id]?.interfaceUsername || row.original.raw?.Onvifusername || row.original.raw?.UserName || ""}
                                                                    onChange={(e) => setCommunicationSettingsByRow(prev => ({...prev, [row.original.id]: {...(prev[row.original.id] || {}), interfaceUsername: e.target.value}}))}
                                                                    style={{
                                                                        border: `1px solid #0b70d1`,
                                                                        padding: "2px 4px",
                                                                        borderRadius: "2px",
                                                                        width: "auto",
                                                                        maxWidth: "50%",
                                                                        background: "transparent",
                                                                        textAlign: "right",
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="info-row">
                                                                <span className="label">Interface Password</span>
                                                                <input
                                                                    type="text"
                                                                    className="value"
                                                                    value={communicationSettingsByRow[row.original.id]?.interfacePassword || row.original.raw?.onvifuserpassword || row.original.raw?.Password || ""}
                                                                    onChange={(e) => setCommunicationSettingsByRow(prev => ({...prev, [row.original.id]: {...(prev[row.original.id] || {}), interfacePassword: e.target.value}}))}
                                                                    style={{
                                                                        border: `1px solid #0b70d1`,
                                                                        padding: "2px 4px",
                                                                        borderRadius: "2px",
                                                                        width: "auto",
                                                                        maxWidth: "50%",
                                                                        background: "transparent",
                                                                        textAlign: "right",
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* Devices Table */}
                                                    <div className="section">
                                                        <div className="section-title">
                                                            <TableViewRoundedIcon sx={{ color: "#158533", mr: 1 }} />
                                                            Devices Details
                                                        </div>

                                                        <div className="info-box" style={{ padding: 0 }}>
                                                            <DeviceDetails
                                                                devices={getRowDeviceDetails(row.original)}
                                                                setDevices={(updatedDevices) =>
                                                                    setDeviceDetailsByRow((prev) => ({
                                                                        ...prev,
                                                                        [row.original.id]: updatedDevices,
                                                                    }))
                                                                }
                                                                // As per device type it should put values nvr dvr and camera dtype === "nvr" || dtype === "dvr" ? "nvr/dvr" : "camera"
                                                                tableFor={row.original.DeviceType === "NVR" || row.original.DeviceType === "DVR" ? "nvr/dvr" : "camera"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Box>
                                    )}
                                    muiTableHeadCellProps={{
                                        className: "myHeaderSelectAll",
                                        sx: {
                                            backgroundColor: "#1976d2",
                                            color: "white",
                                            fontWeight: "bold",
                                        },
                                    }}
                                    muiTableContainerProps={{
                                        className: "MaterialTableJs myTableContainer",
                                        sx: {
                                            maxHeight: "100%",
                                            overflow: "auto",
                                        },
                                    }}
                                    muiTableHeadProps={{
                                        className: "myHeader",
                                        sx: {
                                            display: "table-header-group",
                                        },
                                    }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <div className="d-flex justify-content-center align-items-center">
                                            <h4 style={{ margin: 0 }}>
                                                List of Devices{" "}
                                                {discoverDeviceData.length > 0 &&
                                                    `(${discoverDeviceData.length} records)`}
                                            </h4>
                                        </div>
                                    )}
                                    enableHiding={true}
                                    displayColumnDefOptions={{
                                        "mrt-row-select": {
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    width: 40,
                                                    minWidth: 40,
                                                    maxWidth: 40,
                                                    padding: '0 4px',
                                                },
                                            },
                                            muiTableBodyCellProps: {
                                                sx: {
                                                    width: 40,
                                                    minWidth: 40,
                                                    maxWidth: 40,
                                                    padding: '0 4px',
                                                },
                                            },
                                        },
                                        "mrt-row-expand": {
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    width: 40,
                                                    minWidth: 40,
                                                    maxWidth: 40,
                                                    padding: '0 4px',
                                                },
                                            },
                                            muiTableBodyCellProps: {
                                                sx: {
                                                    width: 40,
                                                    minWidth: 40,
                                                    maxWidth: 40,
                                                    padding: '0 4px',
                                                },
                                            },
                                        },
                                    }}
                                    state={{
                                        rowSelection,
                                        globalFilter,
                                    }}
                                    onRowSelectionChange={setRowSelection}
                                    onGlobalFilterChange={handleGlobalFilterChange}


                                />

                            )}

                        </div>
                    </div>

                </div>

                <div className='mb-2 mt-2' style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    {/* Site Dropdown */}
                    {/* <div className="inputTypeLabelContainer ml-3" style={{ width: "30%" }}>
                        <label className="formFieldLabels">
                            Select Site*
                        </label>
                        <select className="inputType ArrowSelectClass">
                            <option key="0" disabled={false} value="0">
                                Select Site*
                            </option>
                            <option value="1" key="1">
                                Site 1
                            </option>
                            <option value="2" key="2">
                                Site 2
                            </option>
                            <option value="3" key="3">
                                Site 3
                            </option>
                        </select>
                        <p className="Error_P" style={{ float: "left" }}>
                            <span> { } </span>
                        </p>
                    </div> */}
                    <Button
                        className='ConfigBelowButtons mr-3'
                        variant="contained"
                        onClick={handleOnboard}
                        disabled={!Object.values(rowSelection).some(Boolean)}
                    >
                        Onboard Device
                    </Button>
                    <Button className='ConfigBelowButtons mr-3' variant="outlined" onClick={() => { setManualOnBoard(true); showModel(); }}>
                        Update Onvif Device
                    </Button>
                </div>
            </div>
        </div>
            <OnvifManualOnboardModal
                showAdditionalModal={showAdditionalModal}
                onCloseBtn={onCloseBtn}
                selectedRow={null}
                onvifIPAddress={onvifIPAddress}
                setOnvifIPAddress={setOnvifIPAddress}
                onVifIPAddressError={onVifIPAddressError}
                onvifPort={onvifPort}
                setOnvifPort={setOnvifPort}
                onVifPortError={onVifPortError}
                onvifUserName={onvifUserName}
                setOnvifUserName={setOnvifUserName}
                onVifUserNameError={onVifUserNameError}
                onvifPassword={onvifPassword}
                setOnvifPassword={setOnvifPassword}
                onVifPasswordError={onVifPasswordError}
                onSubmitBtn={onSubmitBtn}
                deviceInfoLoading={deviceInfoLoading}
                deviceInfo={deviceInfo}
                deviceName={deviceName}
                setDeviceName={setDeviceName}
                interfaceSubTypeData={interfaceSubTypeData}
                selectedBrand={selectedBrand}
                setSelectedBrand={setSelectedBrand}
                selectedTimeZone={selectedTimeZone}
                setSelectedTimeZone={setSelectedTimeZone}
                timezone={timezone}
                tcpPort={tcpPort}
                setTcpPort={setTcpPort}
                interfaceUserName={interfaceUserName}
                setInterfaceUserName={setInterfaceUserName}
                interfacePassword={interfacePassword}
                setInterfacePassword={setInterfacePassword}
                isEditMode={isEditMode}
                selectedCustomer={selectedCustomer}
                setSelectedCustomer={setSelectedCustomer}
                selectedSite={selectedSite}
                setSelectedSite={setSelectedSite}
                setSiteSearch={setSiteSearch}
                customerOptions={modalCustomerOptions}
                siteOptions={modalSiteOptions}
                devices={devices}
                setDevices={setDevices}
                onBoardDevice={onBoardDevice}
                tableFor={modalTableFor}
                deviceTypeName={deviceInfo?.DeviceType}
                dbProfiles={deviceInfo?.Profiles}
            />

            {/* RTSP stream preview modal (legacy) */}
            <Modal
                show={false}
                onHide={() => onCloseBtn()}
                dialogClassName="DiscoverWidgetModelDiv"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <>
                    <Modal.Header>
                        <Modal.Title id="example-custom-modal-styling-title"
                            title="RTSP Stream">
                                RTSP Stream
                        </Modal.Title>
                        <img
                            src={RemoveIcon}
                            alt="Remove"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                onCloseBtn();
                            }}
                        />
                    </Modal.Header>
                    <Modal.Body>
                            <div style={{height:"500px"}}>
                                <WebRTCPlayer
                                    key={1}
                                    id={1}
                                    url={"rtsp://admin:Intellve%402023@192.168.0.185:554/Streaming/Channels/101"}
                                    isEncode={0}
                                    item={[]}
                                    upperDivCss="singleCameraHover"
                                    videoCss="mosaic"
                                    fullVideoCss="player-responsive-fullScreen"
                                    buttonCss="mosaicButtonsMainDiv"
                                    noStreamDivCss="singleplaybackNoStream"
                                    playback={true}
                                    showPlaybackBtn={true}
                                    // prePostDisplay={false}
                                    liveButton={true}
                                    setStartDateString={""}
                                    setEndDateString={""}
                                    setStartMode={""}
                                    showHooterIcon={false}
                                    showAlertCreation={false}
                                    exportCurrentVideoHide={true}
                                    isSinglePlayback={true}
                                    isExportFuncAllowed={false}
                                    isPlaybackFuncAllowed={false}
                                    />
                            </div>
                    </Modal.Body>
                </>
            </Modal>
        </>
    )
}

export default ViewDiscoverDevices